import { Model as m } from "../../model.js";
class f extends m {
  constructor(e) {
    super(), this.weekDays = e.weekDays, this.startTime = e.startTime, this.endTime = e.endTime, this.fullDay = e.fullDay, this.timezone = e.timezone;
  }
  inDayRange(e) {
    const s = [
      "monday",
      "tuesday",
      "wednesday",
      "thursday",
      "friday",
      "saturday",
      "sunday"
    ][e.weekday - 1];
    return this.weekDays.includes(s);
  }
  inFullRange(e, ...i) {
    if (!this.inDayRange(e))
      return !1;
    if (this.fullDay)
      return !0;
    const [s, r, t] = this.startTime.split(":").map(Number), o = Number.isNaN(t) ? 0 : t, u = e.setZone(this.timezone).set({
      hour: s,
      minute: r,
      second: o
    }), [d, c, n] = this.endTime.split(":").map(Number), y = Number.isNaN(n) ? 0 : n, l = e.setZone(this.timezone).set({
      hour: d,
      minute: c,
      second: y
    }), a = e.setZone(this.timezone);
    return a >= u && a <= l;
  }
}
export {
  f as BaseTimeSlotModel
};
//# sourceMappingURL=baseTimeSlot.model.js.map
